const changeVariableDisplay = function (id, hide = true) {
    document.getElementById(`variable-` + id).style.display = hide ? 'none' : 'block';
}
const invalidAnimal = function (animal) {
    return typeof animal != 'number' || ![0, 1].includes(animal);
}
export default {
    changeVariableDisplay,
    invalidAnimal
}